import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-notifications-view',
  templateUrl: './notifications-view.component.html',
  styleUrls: ['./notifications-view.component.scss']
})
export class NotificationsViewComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
